import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(0 1)">
      <rect width="12" height="2" x="9" y="17" className="euiIcon__fillSecondary"/>
      <rect width="12" height="2" x="9" y="12" className="euiIcon__fillSecondary"/>
      <rect width="12" height="2" x="9" y="7" className="euiIcon__fillSecondary"/>
      <path
        d="M28,0 L8,0 C5.790861,-1.11022302e-16 4,1.790861 4,4 L4,23 L0,23 L0,26 C2.705415e-16,28.209139 1.790861,30 4,30 L22,30 C24.209139,30 26,28.209139 26,26 L26,7 L32,7 L32,4 C32,1.790861 30.209139,2.22044605e-16 28,0 Z M4,28 C2.8954305,28 2,27.1045695 2,26 L2,25 L18,25 L18,26 C18.0012467,26.7025196 18.187493,27.3923207 18.54,28 L4,28 Z M22,28 C20.8954305,28 20,27.1045695 20,26 L20,23 L6,23 L6,4 C6,2.8954305 6.8954305,2 8,2 L24.56,2 C24.2004936,2.60573123 24.0073149,3.29565517 24,4 L24,26 C24,27.1045695 23.1045695,28 22,28 Z M30,5 L26,5 L26,4 C26,2.8954305 26.8954305,2 28,2 C29.1045695,2 30,2.8954305 30,4 L30,5 Z"/>
    </g>
  </svg>
)
